const videoContainer = document.querySelector('.header-video');

if (videoContainer) {
    const fallbackContainer = videoContainer.querySelector('.header-video__fallback-container');
    const videoIframe = videoContainer.querySelector('iframe');

    function switchSources(mediaQuery, fallbackImageUri, videoId, onSwitch) {
        if (!window.matchMedia(mediaQuery).matches) {
            return;
        }

        if (!fallbackContainer) {
            console.warn('No fallback container found for header video');
            return;
        }

        if (!videoIframe) {
            console.warn('No video iframe found for header video');
            return;
        }

        if (fallbackImageUri) {
            const newUrl = 'url("' + fallbackImageUri + '")';
            if (fallbackContainer.style.backgroundImage !== newUrl) {
                fallbackContainer.style.backgroundImage = newUrl;
            }
        }

        if (videoId) {
            if (extractVimeoId(videoIframe.src) !== videoId) {
                videoIframe.src = videoIframe.dataset.src.replace(/video\/\d+/, 'video/' + videoId);
            }
        }

        if (fallbackImageUri && videoId) {
            onSwitch();
        }
    }

    function switchMobile() {
        switchSources(
            '(max-width: 700px)',
            fallbackContainer.dataset.fallbackImageMobile,
            videoIframe.dataset.videoIdMobile,
            () => videoContainer.classList.add('header-video--mobile')
        );
    }

    function switchDesktop() {
        switchSources(
            '(min-width: 701px)',
            fallbackContainer.dataset.fallbackImageDesktop,
            videoIframe.dataset.videoIdDesktop,
            () => videoContainer.classList.remove('header-video--mobile')
        );
    }

    let animationFrameId;

    window.addEventListener('resize', () => {
        cancelAnimationFrame(animationFrameId);
        animationFrameId = requestAnimationFrame(() => {
            switchMobile();
            switchDesktop();
        });
    });

    switchMobile();
    switchDesktop();
}

function extractVimeoId(url) {
    const regex = /(?:https?:\/\/)?(?:www\.)?vimeo\.com\/(?:video\/)?(\d+)/;
    const match = url.match(regex);
    return match ? match[1] : null;
}
